import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { MpAdminService } from "../../services/api/mp-admin.service";
import { MpAdminActions } from "../actions/mp-admin.actions";
import { FailState } from "../models/fail-state";

@Injectable()
export class MpAdminEffects {
	analyticsExclusions = createEffect(() =>
		this.actions.pipe(
			ofType(
				MpAdminActions.analyticsExclusions.get,
				MpAdminActions.analyticsExclusions.setSuccess
			),
			switchMap(() =>
				this.mpAdminService.analyticsExclusions().pipe(
					map((exclusions) =>
						MpAdminActions.analyticsExclusions.getSuccess({
							exclusions,
							loading: false
						})
					),
					catchError((error) =>
						of(MpAdminActions.analyticsExclusions.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	proposalSummaries = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.proposalSummaries.get),
			switchMap(() =>
				this.mpAdminService.proposalSummaries().pipe(
					map((proposals) =>
						MpAdminActions.proposalSummaries.getSuccess({ proposals, loading: false })
					),
					catchError((error) =>
						of(MpAdminActions.proposalSummaries.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	setAnalyticsExclusions = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.analyticsExclusions.set),
			switchMap((action) =>
				this.mpAdminService.setAnalyticsExclusions(action.exclusions).pipe(
					map(() => MpAdminActions.analyticsExclusions.setSuccess()),
					catchError((error) =>
						of(MpAdminActions.analyticsExclusions.setFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private mpAdminService: MpAdminService
	) {}
}
